import type { ReactNode } from 'react';

import { Text } from '../../cdl/Text/Text';
import { Characters } from '../../common/helpers/unicode.helper';
import { Box } from '../../common/ui/Box';

interface DemandMetricCardProps {
    label: string;
    value?: ReactNode;
}

export const DemandMetricCard = ({ label, value }: DemandMetricCardProps) => {
    const valueContent =
        typeof value === 'string' ? (
            <Text variant="subtitle1" truncated>
                {value}
            </Text>
        ) : (
            value
        );

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={2}
            minWidth={0}
            height={74}
            flexShrink={0}
            padding={12}
            backgroundColor="background.inset"
            borderRadius={8}
        >
            <Text variant="small" color="foreground.default" truncated>
                {label}
            </Text>
            <Box
                display="flex"
                alignItems="center"
                gap={6}
                height={24}
                minWidth={0}
                overflow="hidden"
                style={{ whiteSpace: 'nowrap' }}
            >
                {valueContent ?? <Text variant="subtitle1">{Characters.EN_DASH}</Text>}
            </Box>
        </Box>
    );
};
